import './features/LandingPage/LandingPage.css';
import LandingPage from './features/LandingPage/LandingPage';


function App() {
  return (
    <div className="App">
      <LandingPage />
    </div>
  );
}

export default App;
